import { useCallback } from 'react';
import { type NextRouter, useRouter } from 'next/router';

import { reserveFreshArrival } from '../stores/freshArrivals';

type Href = Parameters<NextRouter['push']>[0];

/** 「새 길」을 예약하고 이동한다 — 도착 화면은 이전 길을 잇지 않고 새로 시작한다(방금 만든 퀴즈 등). */
export function useFreshPathNavigation() {
  const router = useRouter();

  return useCallback(
    (href: Href, method: 'push' | 'replace' = 'push') => {
      reserveFreshArrival(
        router,
        typeof href === 'string' ? href : href.pathname ?? '',
      );
      return router[method](href);
    },
    [router],
  );
}
